import {AppLayout} from "base/ui/app/components";
import {SnimfHeaderHero, SnimfMenu} from "snimf/ui";

const SnimfApp = () => {
    return <AppLayout hero={<SnimfHeaderHero />} menu={<SnimfMenu />} />;
};

export default SnimfApp;
